import { Tabs } from "./Tabs";
import { Button, ButtonLink } from "./ContentTabs.styled";

export const ContentTabs = {
  Tabs,
  Button,
  ButtonLink,
};
